import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Spinner, Accordion } from 'react-bootstrap';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddCars = () => {
    const [makers, setMakers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(''); // 'add-maker', 'add-model', 'add-year', 'edit'
    const [editType, setEditType] = useState(''); // 'maker', 'model', 'year'
    const [makerTitle, setMakerTitle] = useState('');
    const [modelTitle, setModelTitle] = useState('');
    const [year, setYear] = useState('');
    const [selectedMakerId, setSelectedMakerId] = useState('');
    const [selectedModelId, setSelectedModelId] = useState('');
    const [selectedYearId, setSelectedYearId] = useState('')
    const [editId, setEditId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showMore, setShowMore] = useState({});

    useEffect(() => {
        fetchMakers();
    }, []);

    useEffect(() => {
        console.log({ modalType, editType, editId });
    }, [modalType, editType, editId]);

    const fetchMakers = async () => {
        try {
            const response = await axios.get('https://drdprints.com/api/get-maker');
            setMakers(response.data.makers);
        } catch (error) {
            console.error('Error fetching makers:', error);
        }
    };

    const handleAddMaker = async () => {
        setLoading(true);
        try {
            await axios.post('https://drdprints.com/api/store-maker', { maker_title: makerTitle });
            toast.success('Maker added successfully!');
            setMakerTitle('');
            fetchMakers();
            setShowModal(false);
        } catch (error) {
            toast.error('Error adding maker. Please try again.');
            console.error('Error adding maker:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleAddModel = async () => {
        setLoading(true);
        try {
            await axios.post('https://drdprints.com/api/store-model', {
                model_title: modelTitle,
                maker_id: selectedMakerId,
            });
            toast.success('Model added successfully!');
            setModelTitle('');
            setSelectedMakerId('');
            fetchMakers();
            setShowModal(false);
        } catch (error) {
            toast.error('Error adding model. Please try again.');
            console.error('Error adding model:', error);
        } finally {
            setLoading(false);
        }
    };

    const groupYearsByModel = (models, years) => {
        const groupedYears = models.map((model) => {
            const modelYears = years.filter((year) => year.model_id === model.id);
            return { model, years: modelYears };
        });
        return groupedYears;
    };

    const handleAddYear = async () => {
        setLoading(true);
        try {
            await axios.post('https://drdprints.com/api/store-year', {
                year,
                maker_id: selectedMakerId,
                model_id: selectedModelId,
            });
            toast.success('Year added successfully!');
            setYear('');
            setSelectedMakerId('');
            setSelectedModelId('');
            fetchMakers();
            setShowModal(false);
        } catch (error) {
            toast.error('Error adding year. Please try again.');
            console.error('Error adding year:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        setLoading(true);
        try {
            if (editType === 'maker') {
                await axios.delete(`https://drdprints.com/api/deletemaker/${editId}`);
            } else if (editType === 'model') {
                await axios.delete(`https://drdprints.com/api/deletemodel/${selectedModelId}`);
            } else if (editType === 'year') {
                await axios.delete(`https://drdprints.com/api/deleteyear/${selectedYearId}`);
            }

            toast.success('Item deleted successfully!');
            setEditType('');
            setEditId(null);
            setSelectedModelId('');
            setSelectedYearId('');
            fetchMakers();
            setShowModal(false);
        } catch (error) {
            toast.error('Error deleting item. Please try again.');
            console.error('Error deleting item:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (maker) => {
        setEditId(maker.id);
        setModalType('edit');
        setEditType('');
        setMakerTitle(maker.maker_title || '');
        setModelTitle('');
        setYear('');
        setSelectedMakerId('');
        setSelectedModelId('');
        setSelectedYearId('');
        setShowModal(true);
    };

    const openDeleteModal = (maker) => {
        setEditId(maker.id);
        setModalType('delete');
        setEditType('');
        setSelectedMakerId('');
        setSelectedModelId('');
        setSelectedYearId('');
        setShowModal(true);
    };

    const openAddModal = (type) => {
        setModalType(type); // Set modal type ('add-maker', 'add-model', or 'add-year')

        // Reset all fields for a clean slate
        setMakerTitle('');
        setModelTitle('');
        setYear('');
        setSelectedMakerId('');
        setSelectedModelId('');
        setSelectedYearId('');
        setEditType(''); // Ensure no lingering editType affects the behavior

        setShowModal(true);
    };

    const handleUpdate = async () => {
        setLoading(true)
        try {
            if (editType === 'maker') {
                await axios.put(`https://drdprints.com/api/update-maker/${editId}`, { maker_title: makerTitle });
            } else if (editType === 'model') {
                await axios.put(`https://drdprints.com/api/update-model/${selectedModelId}`, {
                    maker_id: editId,
                    model_title: modelTitle
                });
            } else if (editType === 'year') {
                await axios.put(`https://drdprints.com/api/update-year/${selectedYearId}`, {
                    maker_id: editId,
                    model_id: selectedModelId,
                    year: year
                });
            }

            setShowModal(false);
            setEditId(null);
            setMakerTitle('');
            setModelTitle('');
            setYear('');
            setSelectedMakerId('');
            setSelectedModelId('');
            fetchMakers();
        } catch (error) {
            console.error('Error updating:', error);
        } finally {
            setLoading(false)
        }
    };

    const toggleShowMore = (modelId) => {
        setShowMore((prevState) => ({
            ...prevState,
            [modelId]: !prevState[modelId],
        }));
    };
    return (
        <div className="container mt-5">
            <ToastContainer position="top-right" autoClose={3000} />
            <h1>Manage Cars</h1>

            <Button className="mt-3" onClick={() => openAddModal('add-maker')}>Add Maker</Button>{' '}
            <Button className="mt-3" onClick={() => openAddModal('add-model')}>Add Model</Button>{' '}
            <Button className="mt-3" onClick={() => openAddModal('add-year')}>Add Year</Button>

            <h2 className="mt-5">Makers, Models, and Years</h2>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Maker</th>
                        <th>Models</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {makers.map((maker) => (
                        <tr key={maker.id}>
                            <td>{maker.maker_title}</td>
                            <td>
                                {maker.model.length > 0 ? (
                                    <div>
                                        {groupYearsByModel(maker.model, maker.year).map(({ model, years }) => (
                                            <div key={model.id} style={{ marginBottom: '1rem', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '4px' }}>
                                                <h5>{model.model_title}</h5>
                                                <ul>
                                                    {years.slice(0, showMore[model.id] ? years.length : 0).map((year) => (
                                                        <li key={year.id}>{year.year}</li>
                                                    ))}
                                                </ul>
                                                {years.length > 0 && (
                                                    <button
                                                        onClick={() => toggleShowMore(model.id)}
                                                        style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer' }}
                                                    >
                                                        {showMore[model.id] ? 'Hide Years' : 'Show Years'}
                                                    </button>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    'No Models'
                                )}
                            </td>
                            <td>
                                <Button variant="warning" className="me-2">Edit</Button>
                                <Button variant="danger">Delete</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Modal */}
            <Modal show={showModal} onHide={() => { setShowModal(false); setEditType(null) }}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modalType === 'add-maker' ? 'Add Maker' : modalType === 'add-model' ? 'Add Model' : modalType === 'add-year' ? 'Add Year' : 'Select Item to Edit'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {/* Edit Type Selection */}
                    {modalType === 'edit' && !editType && (
                        <Form>
                            <Form.Group controlId="formEditType">
                                <Form.Label>Select Item to Edit</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={editType}
                                    onChange={(e) => setEditType(e.target.value)}
                                >
                                    <option value="">Select Type</option>
                                    <option value="maker">Maker</option>
                                    <option value="model">Model</option>
                                    <option value="year">Year</option>
                                </Form.Control>
                            </Form.Group>
                        </Form>
                    )}

                    {/* Delete Type Selection */}
                    {modalType === 'delete' && !editType && (
                        <Form>
                            <Form.Group controlId="formDeleteType">
                                <Form.Label>Select Item to Delete</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={editType}
                                    onChange={(e) => setEditType(e.target.value)}
                                >
                                    <option value="">Select Type</option>
                                    <option value="maker">Maker</option>
                                    <option value="model">Model</option>
                                    <option value="year">Year</option>
                                </Form.Control>
                            </Form.Group>
                        </Form>
                    )}


                    {/* Add Maker Modal */}
                    {modalType === 'add-maker' && (
                        <Form>
                            <Form.Group controlId="formMakerTitle">
                                <Form.Label>Maker Title</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter maker title"
                                    value={makerTitle}
                                    onChange={(e) => setMakerTitle(e.target.value)}
                                />
                            </Form.Group>
                        </Form>
                    )}

                    {/* Add Model Modal */}
                    {modalType === 'add-model' && (
                        <Form>
                            <Form.Group controlId="formMakerId">
                                <Form.Label>Maker</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedMakerId}
                                    onChange={(e) => setSelectedMakerId(e.target.value)}
                                >
                                    <option value="">Select Maker</option>
                                    {makers.map((maker) => (
                                        <option key={maker.id} value={maker.id}>
                                            {maker.maker_title}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="formModelTitle" className="mt-2">
                                <Form.Label>Model Title</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter model title"
                                    value={modelTitle}
                                    onChange={(e) => setModelTitle(e.target.value)}
                                />
                            </Form.Group>
                        </Form>
                    )}

                    {/* Add Year Modal */}
                    {modalType === 'add-year' && (
                        <Form>
                            <Form.Group controlId="formMakerId">
                                <Form.Label>Maker</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedMakerId}
                                    onChange={(e) => {
                                        setSelectedMakerId(e.target.value);
                                        setSelectedModelId(''); // Reset Model selection when Maker changes
                                    }}
                                >
                                    <option value="">Select Maker</option>
                                    {makers.map((maker) => (
                                        <option key={maker.id} value={maker.id}>
                                            {maker.maker_title}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            {selectedMakerId && (
                                <Form.Group controlId="formModelId" className="mt-2">
                                    <Form.Label>Model</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={selectedModelId}
                                        onChange={(e) => setSelectedModelId(e.target.value)}
                                    >
                                        <option value="">Select Model</option>
                                        {makers
                                            .find((maker) => maker.id === parseInt(selectedMakerId))?.model.map((model) => (
                                                <option key={model.id} value={model.id}>
                                                    {model.model_title}
                                                </option>
                                            ))}
                                    </Form.Control>
                                </Form.Group>
                            )}
                            {selectedModelId && (
                                <Form.Group controlId="formYear" className="mt-2">
                                    <Form.Label>Year</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter year"
                                        value={year}
                                        onChange={(e) => setYear(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </Form>
                    )}

                    {/* Edit Maker */}
                    {modalType === 'edit' && editType === 'maker' && (
                        <Form>
                            <Form.Group controlId="formMakerTitle">
                                <Form.Label>Maker Title</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter maker title"
                                    value={makerTitle}
                                    onChange={(e) => setMakerTitle(e.target.value)}
                                />
                            </Form.Group>
                        </Form>
                    )}

                    {/* Edit Model */}
                    {modalType === 'edit' && editType === 'model' && (
                        <Form>
                            <Form.Group controlId="formModelId" className="mt-2">
                                <Form.Label>Model</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedModelId}
                                    onChange={(e) => setSelectedModelId(e.target.value)}
                                >
                                    <option value="">Select Model</option>
                                    {makers
                                        .find((maker) => maker.id === editId)?.model.map((model) => (
                                            <option key={model.id} value={model.id}>
                                                {model.model_title}
                                            </option>
                                        )) || (
                                            <option disabled>No Models Available</option>
                                        )}
                                </Form.Control>
                            </Form.Group>
                            {selectedModelId && (
                                <Form.Group controlId="formModelTitle" className="my-2">
                                    <Form.Label>Model Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter model title"
                                        value={modelTitle}
                                        onChange={(e) => setModelTitle(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </Form>
                    )}

                    {/* Edit Year */}
                    {modalType === 'edit' && editType === 'year' && (
                        <Form>
                            <Form.Group controlId="formModelId" className="mt-2">
                                <Form.Label>Model</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedModelId}
                                    onChange={(e) => setSelectedModelId(e.target.value)}
                                >
                                    <option value="">Select Model</option>
                                    {makers
                                        .find((maker) => maker.id === editId)?.model.map((model) => (
                                            <option key={model.id} value={model.id}>
                                                {model.model_title}
                                            </option>
                                        )) || (
                                            <option disabled>No Models available</option>
                                        )}
                                </Form.Control>
                            </Form.Group>
                            {selectedModelId &&
                                <Form.Group controlId="formYearId" className="mt-3">
                                    <Form.Label>Select Year</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={selectedYearId}
                                        onChange={(e) => setSelectedYearId(e.target.value)}
                                    >
                                        <option value="">Select Year</option>
                                        {makers
                                            .find((maker) => maker.id === editId)?.year.filter(
                                                (year) => year.model_id === parseInt(selectedModelId)
                                            ).map((year) => (
                                                <option key={year.id} value={year.id}>
                                                    {year.year}
                                                </option>
                                            )) || (
                                                <option disabled>No Year available</option>
                                            )}
                                    </Form.Control>
                                </Form.Group>
                            }
                            {selectedYearId && <Form.Group controlId="formYear" className="mt-2">
                                <Form.Label>Year</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter year"
                                    value={year}
                                    onChange={(e) => setYear(e.target.value)}
                                />
                            </Form.Group>}
                        </Form>
                    )}

                    {/* Delete Maker */}
                    {modalType === 'delete' && editType === 'maker' && (
                        <p className="text-danger mt-3">Are you sure you want to delete this Maker? This action cannot be undone.</p>
                    )}

                    {/* Delete Model */}
                    {modalType === 'delete' && editType === 'model' && (
                        <Form>
                            <Form.Group controlId="formModelId" className="mt-2">
                                <Form.Label>Model</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedModelId}
                                    onChange={(e) => setSelectedModelId(e.target.value)}
                                >
                                    <option value="">Select Model</option>
                                    {makers
                                        .find((maker) => maker.id === editId)?.model.map((model) => (
                                            <option key={model.id} value={model.id}>
                                                {model.model_title}
                                            </option>
                                        )) || (
                                            <option disabled>No Models available</option>
                                        )}
                                </Form.Control>
                            </Form.Group>
                            {selectedModelId && (
                                <p className="text-danger mt-3">
                                    Are you sure you want to delete this Model? This action cannot be undone.
                                </p>
                            )}
                        </Form>
                    )}

                    {/* Delete Year */}
                    {modalType === 'delete' && editType === 'year' && (
                        <Form>
                            <Form.Group controlId="formModelId" className="mt-2">
                                <Form.Label>Model</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedModelId}
                                    onChange={(e) => setSelectedModelId(e.target.value)}
                                >
                                    <option value="">Select Model</option>
                                    {makers
                                        .find((maker) => maker.id === editId)?.model.map((model) => (
                                            <option key={model.id} value={model.id}>
                                                {model.model_title}
                                            </option>
                                        )) || (
                                            <option disabled>No Models available</option>
                                        )}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="formYearId" className="mt-2">
                                <Form.Label>Select Year</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedYearId}
                                    onChange={(e) => setSelectedYearId(e.target.value)}
                                >
                                    <option value="">Select Year</option>
                                    {makers
                                        .find((maker) => maker.id === editId)?.year.filter(
                                            (year) => year.model_id === parseInt(selectedModelId)
                                        ).map((year) => (
                                            <option key={year.id} value={year.id}>
                                                {year.year}
                                            </option>
                                        )) || (
                                            <option disabled>No Years available</option>
                                        )}
                                </Form.Control>
                            </Form.Group>
                            {selectedYearId && (
                                <p className="text-danger mt-3">
                                    Are you sure you want to delete this Year? This action cannot be undone.
                                </p>
                            )}
                        </Form>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>

                    {modalType === 'add-maker' || modalType === 'add-model' || modalType === 'add-year' ? (
                        <Button variant="primary" disabled={loading} onClick={() => {
                            if (modalType === 'add-maker') handleAddMaker();
                            if (modalType === 'add-model') handleAddModel();
                            if (modalType === 'add-year') handleAddYear();
                        }}>
                            {loading ? <Spinner animation="border" size="sm" /> : 'Add'}
                        </Button>
                    ) : null}

                    {modalType === 'edit' ? (
                        <Button variant="primary" onClick={handleUpdate} disabled={loading}>
                            {loading ? <Spinner animation="border" size="sm" /> : 'Save Changes'}
                        </Button>
                    ) : null}

                    {modalType === 'delete' ? (
                        <Button
                            variant="danger"
                            disabled={
                                !(
                                    (editType === 'maker') ||
                                    (editType === 'model' && selectedModelId) ||
                                    (editType === 'year' && selectedYearId) || !loading
                                )
                            }
                            onClick={handleDelete}
                        >
                            {loading ? <Spinner animation="border" size="sm" /> : 'Delete'}
                        </Button>
                    ) : null}
                </Modal.Footer>



            </Modal>



        </div >
    );
};

export default AddCars;

